import { ProjectStatus } from '@uniquegood/realworld-admin-interface';

export const gameStatusToLabel = {
  [ProjectStatus.Released]: '공개',
  [ProjectStatus.Unreleased]: '미공개',
  [ProjectStatus.Preparing]: '준비중',
  [ProjectStatus.Deleted]: '삭제됨'
};
